import * as Yup from 'yup';

const settingsSchema = Yup.object().shape({
    GA: Yup.string(),
    GTM: Yup.string(),
});

export default settingsSchema;
